import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['main', 'content'];

  initialize() {
    this._isAnimating = false;
  }

  connect() {
    if (!this.hasMainTarget || !this.hasContentTarget) {
      return;
    }

    // Add just in case, but you would want to add it in html to avoid some flickering
    this.element.classList.add('more-content');
    this.mainTarget.classList.add('more-content__source');
    this.contentTarget.classList.add('more-content__target');

    this.contentTarget.addEventListener('transitionend', () => {
      if (this.element.classList.contains('more-content--hidden')) {
      } else {
        this.contentTarget.style.height = '';
      }
    });

    this.update();
  }

  toggle() {
    if (this.element.classList.contains('more-content--hidden')) {
      this.element.classList.remove('more-content--hidden');
      this.element.classList.add('more-content--visible');
      this.contentTarget.style.height = `${this.contentTarget.scrollHeight}px`;
    } else {
      this.contentTarget.style.height = `${this.contentTarget.clientHeight}px`;
      this.element.classList.remove('more-content--visible');
      this.element.classList.add('more-content--hidden');

      requestAnimationFrame(() => {
        this.contentTarget.style.height = `${this.mainTarget.clientHeight}px`;
      });
    }
  }

  update() {
    if (this.mainTarget.getBoundingClientRect().top !== this.contentTarget.getBoundingClientRect().top) {
      return;
    }

    const mainHeight = this.mainTarget.clientHeight;
    const contentHeight = this.contentTarget.clientHeight;

    if (contentHeight > mainHeight) {
      this.element.classList.add('more-content--hidden');
      this.contentTarget.style.height = `${mainHeight}px`;
    }
  }
}
